<template>
  <div class="assembly-work-order">
    <!--列表-->
    <el-table size="small" :data="listData" :key="uniqueKey" highlight-current-row v-loading="loading" max-height="400px" stripe border element-loading-text="拼命加载中" :header-cell-style="_headerStyle" style="width: 100%;"  @cell-mouse-enter="handleCellEnter"
      @cell-mouse-leave="handleCellLeave" row-key="_id">
      <el-table-column type="selection" width="60" :reserve-selection="true">
      </el-table-column>
      <el-table-column prop="no" label="序号" type="index" width="50"></el-table-column>
      <el-table-column prop="processName" label="工序名称" width="180">
      </el-table-column>
      <el-table-column  prop="processCode" label="工序编号" width="180">
        <template slot-scope="scope">
          <span>{{scope.row.processCode}}</span>
          <el-tag v-for="(item,index) in scope.row.status" :type="changeStatusColor(item)" :key="item" style="height:28px;margin-left: 4px;" :style="{'marginBottom':(index!=scope.row.status.length-1)?'8px':'0'}">{{item}}</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="technologyName" label="工艺路线名称" width="180">
      </el-table-column>
      <el-table-column prop="technologyCode" label="工艺路线编号" width="180">
      </el-table-column> -->
      <el-table-column  prop="userNameList" label="报工权限" width="80">
        <template slot-scope="scope">
          <div>{{scope.row.userNameList && scope.row.userNameList.join(',')}}</div>
        </template>
      </el-table-column>
      <el-table-column  prop="coefficient" label="报工数配比" width="120">
        <div class="item" slot-scope="scope" >
          <div v-if="scope.row.type == 'process' && mode == 'create'">
            <el-input class="item__input" v-model="scope.row.coefficient" @input="coefficientInput(scope.row)" placeholder="请输入内容" size="mini" style="width:100%;"></el-input>
            <div class="item__txt">{{scope.row.coefficient}}</div>
          </div>
          <div v-if="scope.row.type == 'technology' && mode == 'create'">

          </div>
          <span v-if="mode != 'create'"> {{scope.row.coefficient}}</span>
        </div>
      </el-table-column>
      <el-table-column  prop="planNum" label="计划数" width="80">
        <div class="item" slot-scope="scope">

          <div  v-if="scope.row.type == 'process' && mode == 'create'">
            <!-- <el-input class="item__input" v-model="scope.row.planNum" placeholder="请输入内容" size="mini" style="width:100%;"></el-input> -->
            <div class="item__txt">{{scope.row.planNum}}</div>
          </div>
          <div  v-if="scope.row.type == 'technology' && mode == 'create'">

          </div>
          <span v-if="mode != 'create'"> {{scope.row.planNum}}</span>

        </div>
      </el-table-column>
      <el-table-column  prop="goodNum" label="良品数" width="180">
        <div slot-scope="scope" >
          <span v-if="scope.row.type == 'process'">{{scope.row.goodNum}}</span>
        </div>
      </el-table-column>
      <el-table-column  prop="nongoodNum" label="不良品数" width="180">
        <div slot-scope="scope" >
          <span v-if="scope.row.type == 'process'">{{scope.row.nongoodNum}}</span>
        </div>
      </el-table-column>
      <el-table-column sortable prop="nongoodNameList" label="不良品项列表" width="150">
        <template slot-scope="scoped">
          <div>{{scoped.row.nongoodNameList && scoped.row.nongoodNameList.join('、')}}</div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="planStartTime" label="计划开始时间" width="150"></el-table-column>
      <el-table-column  prop="planEndTime" label="计划结束时间" width="150"></el-table-column>
      <!-- <el-table-column  prop="actualStartTime" label="实际开始时间" width="150"></el-table-column>
      <el-table-column  prop="actualEndTime" label="实际结束时间" width="150"></el-table-column> -->
      <el-table-column v-for="item in setList" :key="item._id" :prop="item.fieldName" :label="item.fieldName"></el-table-column>

      <el-table-column label="操作" min-width="180" fixed="right" v-if="formData.orderStatus == '未开始'">
        <template slot-scope="scope">
          <el-tooltip content="编辑">
            <el-button type="primary" size="mini" icon="el-icon-edit" circle @click="handleEdit(scope.$index, scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip content="删除">
            <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="handleDelete(scope.$index, scope.row)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
      <!-- 编辑工序弹窗 -->
    <el-dialog title="编辑工序" :visible.sync="orderVisible" width="50%" @cancel="closeOrder" :close-on-click-modal="false">
      <order-detail v-if="orderVisible" @done="closeOrder" :editRow="editRow" :setList="setList" :modelStatus="modelStatus" :mode="mode"></order-detail>
    </el-dialog>
  </div>
</template>

<script>
// import moment from 'moment'
import OrderDetail from "@/views/order/dialogManage/order-detail.vue";
import {queryAllCustomSet} from '@/api/business';
export default {
  props:['formData','mode'],
  // 注册组件
  components: {
    OrderDetail,
  },
  watch:{
    'formData.planTime':{
        handler(newValue) {
          var _this = this
            var listData = JSON.parse(JSON.stringify(this.listData))
            this.listData = []
            listData.map(function(item){
              _this.$set(item,'planStartTime',newValue[0] + ':00')
              _this.$set(item,'planEndTime',newValue[1] + ':59')
              _this.listData.push(item)
            })
        },
        deep: true,
        immediate: true
      }
  },

  /**
   * 创建完毕
   */
  created() {
    var _this = this
    this.init();
    if(this.formData.produceTasks){
      var listData = JSON.parse(JSON.stringify(this.formData.produceTasks))
      this.listData = []
      listData.map(function(item){
        _this.listData.push(item)
      })
    }
  },
  data() {
    return {
      setList:[],
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: '请请输入部门名称', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请请输入部门代码', trigger: 'blur' }]
      },
      form: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken'),
        updateCondition:'0',
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      //mode:'main',
      orderVisible:false,
      editRow:{},//编辑工序对象
      // 需要编辑的属性
      editProp: ['coefficient','planNum'],
      uniqueKey:new Date().getTime(),
      userData:JSON.parse(localStorage.getItem('userdata')),
      modelStatus:''
    }
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    async init(){
      let res = await queryAllCustomSet(this.userData.factoryId,'process');
      this.setList = [];
      if(res['code'] == 200){
        this.setList = res['data'];
      }
    },
    updateData(data){
      this.listData = JSON.parse(JSON.stringify(data));
    },
    changeData(options){
      options.map(function(item,index){
        // item.workReportAuth = '所有人'
        item.planStartTime = this.formData.planTime[0] + ':00'
        item.planEndTime = this.formData.planTime[1] + ':59'
        item.planNum = (item['coefficient'] && !isNaN(item['coefficient']))?item['coefficient'] * this.formData.planNum:0
        item.goodNum = 0
        item.nongoodNum = 0
        item.actualStartTime = ''
        item.actualEndTime = ''
        item.curIndex = index
        this.listData.push(item)
      }.bind(this))

    },
    changeData1(options){
      this.listData = [];
      options.map(function(item,index){
        // item.workReportAuth = '所有人'
        item.planStartTime = this.formData.planTime[0] + ':00'
        item.planEndTime = this.formData.planTime[1] + ':59'
        item.planNum = (item['coefficient'] && !isNaN(item['coefficient']))?item['coefficient'] * this.formData.planNum:0
        item.goodNum = 0
        item.nongoodNum = 0
        item.actualStartTime = ''
        item.actualEndTime = ''
        item.curIndex = index
        this.listData.push(item)
      }.bind(this))


    },
    handleDelete(index, row) {
      if(row.taskStatus == "未开始" || (row.goodNum == 0 && row.nongoodNum == 0)){

        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            this.listData.splice(index,1)
            // 更新索引
            this.listData.map(function(item,index){
              item.curIndex = index
            })
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      }else{
          this.$message({
            type: 'warning',
            message: '当前生产任务已报工，无法删除！'
          });
      }
    },
    handleEdit(index, row){
      this.modelStatus = 'edit'
      this.editRow = row
      this.orderVisible = true
    },
    closeOrder(options){
      var _this = this
      this.orderVisible = false
      if(options.type == 'save'){
        this.listData.map(function(item){
          if(_this.editRow._id === item._id){
            _this.$set(item,'planNum',options.data.planNum)
            _this.$set(item,'coefficient',options.data.coefficient)
            _this.$set(item,'planStartTime',options.data.planStartTime)
            _this.$set(item,'planEndTime',options.data.planEndTime)
            for(let i =0; i<_this.setList.length;i++){
              _this.$set(item,_this.setList[i]['fieldName'],options.data[_this.setList[i]['fieldName']])
            }
          }
        })
        this.uniqueKey = new Date().getTime()
        this.editRow = {}
      }
    },
    changeStatusColor(options){
      if(options == '延期'){
        return 'danger'
      }else if(options == '执行中'){
        return 'success'
      }{
        return ''
      }
    },
    /** 鼠标移入cell */
    handleCellEnter (row, column, cell, event) {
      // if(this.mode != 'create') return;
      if(true) return;
      if(row.type == "technology"){
        return ;
      }
      const property = column.property
      if (this.editProp.includes(property)) {
        cell.querySelector('.item__input').style.display = 'block'
        cell.querySelector('.item__txt').style.display = 'none'
      }
    },
    /** 鼠标移出cell */
    handleCellLeave (row, column, cell, event) {
      // if(this.mode != 'create') return;
      if(true) return;

      if(row.type == "technology"){
        return ;
      }
      const property = column.property
      if (this.editProp.includes(property)) {
        cell.querySelector('.item__input').style.display = 'none'
        cell.querySelector('.item__txt').style.display = 'block'
      }
    },
    coefficientInput(row){
      if(row['coefficient'] && !isNaN(row['coefficient'])){
        row['planNum'] = parseInt(row['coefficient']) * this.$parent.$data.form.planNum;
      }else{
        row['planNum'] = 0;
      }
      // if(row['type'] == "process"){
      // }
    }

  }
}
</script>

<style scoped>
 .item .item__input {
  display: none;
  width: 100px;
 }
 .item .item__txt{
  box-sizing: border-box;
  line-height: 24px;
  padding: 0 9px;
}
 .item .item__input .el-input__inner{
  height: 24px!important;
 }
 .item .item__input .el-input__inner .el-input__suffix i{
  font-size: 12px !important;
  line-height: 26px !important;
 }
</style>





// WEBPACK FOOTER //
// src/views/order/list-table.vue